<template>
  <layout-quarter bg="/images/photo-3.jpg">
    <h1 class="heading h2 t-inverse t-center">
      What type of property are you looking for?
    </h1>

    <div class="button-group">
      <label class="button button--square button--toggle" :class="{ 'is-active' : selectedTypes.includes(type.Id) }" v-for="type in propertyMacroTypes" :key="type.Id">
        <input 
          type="checkbox"
          :value="type.Id"
          v-model="selectedTypes"
        >
        {{ type.Name }} 
      </label>
    </div>

    <router-link class="button" to="location" :disabled="!selectedTypes.length">Next</router-link>
    <a class="button button--link" @click="$router.back()">Back</a>
  </layout-quarter>
</template>

<style scoped lang="scss">
  
</style>

<script>
  import { mapState } from 'vuex';
  import LayoutQuarter from '@/layouts/Quarter';
  import ButtonSelect from '@/components/ButtonSelect'

  export default {
    name: 'PropertyType',

    components: {
      LayoutQuarter,
      ButtonSelect
    },

    computed: {
      ...mapState([
        'propertyMacroTypes'
      ]),

      selectedTypes: {
        get () {
          return this.$store.state.filters.propertyMacroTypes;
        },

        set (value) {
          this.$store.commit('updatePropertyMacroTypesFilter', value)
        }
      }
    }
  };
</script>